import { auth } from 'components/providers/GetGoAuthProvider'
import config from 'config'

const handleErrors = (response: Response, handleUnauthorized = true) => {
  if (response.status === 401 && handleUnauthorized) {
    localStorage.removeItem(config.AUTH_TOKEN_KEY)
    localStorage.removeItem(config.I_AM_TOKEN_KEY)

    auth.login({
      state: { inflightRequest: window.location.pathname },
    })

    throw Error(response.statusText || 'Unauthorized')
  }
  return response
}

const fetchAdmin = async (input: RequestInfo, init?: RequestInit, handleUnauthorized?: boolean): Promise<Response> => {
  // Parsing the oauth token from localStorage
  const tokenName = config.AUTH_TOKEN_KEY
  const token = JSON.parse(localStorage.getItem(tokenName) || '{}')
  const { token_type, access_token } = token

  return fetch(input, {
    ...init,
    headers: {
      Authorization: `${token_type} ${access_token}`,
      ...init?.headers,
    },
  }).then((res) => handleErrors(res, handleUnauthorized))
}

export default fetchAdmin
